/** @jsxImportSource @emotion/react */
import {
  FeedCard,
  Column,
  Text,
  TEXT_VARIANTS,
  ExternalLink,
  Tagline,
} from "../..";

export const PersonCard: React.FC = () => (
  <FeedCard path="/person/id">
    <Column crossAxisAlignment="start" gap={5}>
      <Text as="h3" variant={TEXT_VARIANTS.T30}>
        {"Dieter Rams"}
      </Text>
      <Tagline text="person · updated 3h ago" entities={[]} />
      <Text as="p" variant={TEXT_VARIANTS.T20}>
        {"Industrial designer"}
      </Text>
      <ExternalLink>{"en.wikipedia.org"}</ExternalLink>
    </Column>
  </FeedCard>
);
